module.exports = __webpack_public_path__ + "img/teeth-42.29549227.png";